// // src/pages/Cotacao.js - VERSÃO FINAL COM XML NO HISTÓRICO
// import React, { useState, useEffect } from 'react';
// import { auth, db } from '../firebase';
// import { doc, getDoc, setDoc } from 'firebase/firestore';
// import { signOut } from 'firebase/auth';
// import { useNavigate } from 'react-router-dom';

// const itensContratoBase = [
//     { nome: "Lanche simples", descricao: "Lanche simples – Sanduiche pão e ovo, salgados ou bolo com refrigerante e suco, café com leite.", valor: 18.50 },
//     { nome: "Quentinha", descricao: "Quentinha – carne, frango ou peixe, arroz, feijão, farofa, salada ou baião e refrigerante.", valor: 27.00 },
//     { nome: "Almoço", descricao: "Almoço – frango, carne ou linguiça, arroz, farofa, feijão, salada ou baião e refrigerante.", valor: 32.50 },
//     { nome: "Coffee Break", descricao: "Coffee Break – por pessoa três tipos de salgados, dois tipos de frutas, torta salgada, bolo, pão, patês variados, torrada, dois tipos de suco, refrigerante, café e leite.", valor: 44.00 },
//     { nome: "Buffet", descricao: "Buffet – (tipo americano) – 02 tipos de carnes vermelhas, 01 tipo de carne branca, 02 tipos de arroz (branco ou outro), 02 tipo de macarrão (espaguete ou fusilli), 02 tipo de farofa (farinha ou cuscuz), 02 tipos de salada (crua ou cozida), sobremesa gelada, bebidas: agua mineral 330ml ou agua mineral com gás 330ml e 250ml de sucos regionais ou 250ml de refrigerante, utensílios: copos, pratos, talheres, guardanapos de papel folha dupla.", valor: 78.50 }
// ];
// const saldosMestreIniciais = {
//   "Assistência Social": { "Lanche simples": 200, "Quentinha": 800, "Almoço": 200, "Coffee Break": 700, "Buffet": 1200 },
//   "Finanças": { "Lanche simples": 300, "Quentinha": 1000, "Almoço": 300, "Coffee Break": 700, "Buffet": 1200 },
//   "Saúde": { "Lanche simples": 100, "Quentinha": 500, "Almoço": 100, "Coffee Break": 700, "Buffet": 1200 },
//   "Educação": { "Lanche simples": 300, "Quentinha": 1000, "Almoço": 300, "Coffee Break": 700, "Buffet": 1200 },
// };
// const criarCotacaoVazia = () => {
//     const cotacaoVazia = {};
//     Object.keys(saldosMestreIniciais).forEach(sec => {
//         cotacaoVazia[sec] = itensContratoBase.map(item => ({ ...item, usado: 0 }));
//     });
//     return cotacaoVazia;
// };
// function removerAcentos(texto) {
//     if (!texto) return "";
//     return texto.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
// }


// function Cotacao() {
//   const navigate = useNavigate();
//   const [cotacaoAtual, setCotacaoAtual] = useState(criarCotacaoVazia());
//   const [saldosMestre, setSaldosMestre] = useState(null);
//   const [isSaving, setIsSaving] = useState(false);
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [reportText, setReportText] = useState('');
//   const [date, setDate] = useState(new Date().toISOString().split('T')[0]);
//   const [printHtml, setPrintHtml] = useState('');

//   useEffect(() => {
//     const carregarSaldos = async () => {
//       const docRef = doc(db, "saldos", "por_secretaria");
//       const docSnap = await getDoc(docRef);
//       if (docSnap.exists()) {
//         const dadosDoFirestore = docSnap.data();
//         const saldosCompletos = { ...saldosMestreIniciais };
//         for (const sec in saldosCompletos) {
//             if (dadosDoFirestore[sec]) {
//                 saldosCompletos[sec] = { ...saldosMestreIniciais[sec], ...dadosDoFirestore[sec] };
//             }
//         }
//         setSaldosMestre(saldosCompletos);
//       } else {
//         await setDoc(docRef, saldosMestreIniciais);
//         setSaldosMestre(saldosMestreIniciais);
//       }
//     };
//     carregarSaldos();
//   }, []);

//   useEffect(() => {
//     if (printHtml) {
//       const timer = setTimeout(() => { window.print(); setPrintHtml(''); }, 500);
//       return () => clearTimeout(timer);
//     }
//   }, [printHtml]);

//   const alterarQtd = (secretaria, itemIndex, novoValor) => {
//     const valorNum = parseInt(novoValor) || 0;
//     const item = cotacaoAtual[secretaria][itemIndex];
//     const saldoDisponivel = saldosMestre[secretaria][item.nome];
//     if (valorNum > saldoDisponivel) {
//         alert(`Quantidade não permitida!\nO saldo máximo para "${item.nome}" na secretaria "${secretaria}" é ${saldoDisponivel}.`);
//         const novaCotacao = { ...cotacaoAtual };
//         novaCotacao[secretaria][itemIndex].usado = saldoDisponivel;
//         setCotacaoAtual(novaCotacao);
//         return;
//     }
//     const novaCotacao = { ...cotacaoAtual };
//     novaCotacao[secretaria][itemIndex].usado = valorNum;
//     setCotacaoAtual(novaCotacao);
//   };

//   const handleEfetivarCotacao = async () => {
//     // ... (lógica inicial da função continua a mesma)
//     if (isSaving) return;
//     let consumoTotal = 0;
//     let valorTotalCotacao = 0;
//     Object.values(cotacaoAtual).forEach(secretaria => {
//         secretaria.forEach(item => { 
//             consumoTotal += item.usado;
//             valorTotalCotacao += item.usado * item.valor;
//         });
//     });

//     if (consumoTotal === 0) {
//       alert("Nenhum item foi adicionado à cotação para efetivar.");
//       return;
//     }
//     const novosSaldosMestre = JSON.parse(JSON.stringify(saldosMestre));
//     let validationFailed = false;
//     for (const secretaria in cotacaoAtual) {
//       for (const item of cotacaoAtual[secretaria]) {
//         if (item.usado > 0) {
//           if (saldosMestre[secretaria][item.nome] < item.usado) {
//             validationFailed = true; break; 
//           }
//           novosSaldosMestre[secretaria][item.nome] -= item.usado;
//         }
//       }
//       if (validationFailed) break;
//     }
//     if(validationFailed) { alert("Erro de validação. A quantidade excede o saldo disponível."); return; }

//     if (window.confirm("Tem certeza que deseja efetivar esta cotação? Os saldos serão atualizados e a cotação será salva no histórico.")) {
//       setIsSaving(true);
//       try {
//         const saldosDocRef = doc(db, "saldos", "por_secretaria");
//         await setDoc(saldosDocRef, novosSaldosMestre);

//         const idCotacao = `COT-${Date.now()}`;
//         const historicoDocRef = doc(db, "historico_cotacoes", idCotacao);

//         // ALTERADO: Chamar a função para gerar a string XML
//         const xmlString = gerarStringXML();

//         const dadosParaSalvar = {
//             id: idCotacao,
//             dataEfetivacao: new Date().toISOString(),
//             dataOrcamento: date,
//             status: "Efetivada",
//             valorTotal: valorTotalCotacao,
//             detalhes: cotacaoAtual,
//             xmlString: xmlString // NOVO: Adiciona a string do XML aos dados salvos
//         };

//         await setDoc(historicoDocRef, dadosParaSalvar);
        
//         setSaldosMestre(novosSaldosMestre);
//         setCotacaoAtual(criarCotacaoVazia());
//         alert("Cotação efetivada e salva no histórico com sucesso!");
//       } catch (error) {
//         console.error("Erro ao efetivar cotação:", error);
//         alert("Ocorreu um erro. Por favor, tente novamente.");
//       } finally {
//         setIsSaving(false);
//       }
//     }
//   };
  
//   const gerarRelatorioTexto = () => {
//     // ... (sem alterações nesta função)
//     let relatorios = [];
//     let abriuAlguma = false;
//     Object.keys(cotacaoAtual).forEach(secretaria => {
//       let itensRelatorio = [];
//       let totalSecretaria = 0;
//       cotacaoAtual[secretaria].forEach(item => {
//         if (item.usado > 0) {
//           abriuAlguma = true;
//           const valorTotalItem = item.usado * item.valor;
//           totalSecretaria += valorTotalItem;
//           const linhaItem = `${item.usado} - ${item.descricao} VALOR UNITÁRIO: R$ ${item.valor.toFixed(2)}. TOTAL: R$ ${valorTotalItem.toFixed(2)}`;
//           itensRelatorio.push(linhaItem);
//         }
//       });
//       if (itensRelatorio.length > 0) {
//         let relatorioSecretaria = `SERVIÇO DE ALIMENTAÇÃO FORNECIDO À SECRETARIA DE ${secretaria.toUpperCase()} DESTE MUNICÍPIO\n\n`;
//         relatorioSecretaria += itensRelatorio.join('\n');
//         relatorioSecretaria += `\n\nTOTAL: R$ ${totalSecretaria.toFixed(2)}`;
//         relatorios.push(relatorioSecretaria);
//       }
//     });
//     if (!abriuAlguma) { alert("Nenhum item foi selecionado para gerar o relatório!"); return; }
//     const textoFinal = relatorios.join('\n\n==================================================\n\n');
//     setReportText(textoFinal);
//     setIsModalOpen(true);
//   };
  
//   const imprimirCotacoes = () => {
//     // ... (sem alterações nesta função)
//     let paginasHtml = [];
//     let abriuAlguma = false;
//     const dataOrcamento = new Date(date + 'T00:00:00');
//     const dataFormatada = dataOrcamento.toLocaleDateString('pt-BR', { day: '2-digit', month: 'long', year: 'numeric' });
//     const local = "Lagoa do Mato, Itatira - CE";
//     Object.keys(cotacaoAtual).forEach(secretaria => {
//       let linhasTabela = [];
//       let totalGeralSecretaria = 0;
//       let contador = 1;
//       cotacaoAtual[secretaria].forEach(item => {
//         if (item.usado > 0) {
//           abriuAlguma = true;
//           const totalItem = item.usado * item.valor;
//           totalGeralSecretaria += totalItem;
//           linhasTabela.push(`<tr><td>${contador++}</td><td>${item.descricao}</td><td>${item.usado}</td><td>R$ ${item.valor.toFixed(2)}</td><td>R$ ${totalItem.toFixed(2)}</td></tr>`);
//         }
//       });
//       if (linhasTabela.length > 0) {
//         paginasHtml.push(
//           `<div class="pagina-cotacao">
//             <header class="print-header"><div class="print-header-inner"><img src="./assets/logo.png" alt="Logo"></div></header>
//             <main class="print-main">
//               <div>
//                 <div class="print-titulo">ORÇAMENTO</div>
//                 <div class="print-cabecalho"><strong>Tomador:</strong> <span>MUNICÍPIO DE ITATIRA  - Secretaria de ${secretaria}</span><br /><strong>CNPJ:</strong> <span>07.963.739/0001-48</span></div>
//                 <table>
//                   <thead><tr><th style="width:60px;">ITEM</th><th>ESPECIFICAÇÕES</th><th style="width:60px;">Qtd</th><th style="width:100px;">Valor unit.</th><th style="width:100px;">Total</th></tr></thead>
//                   <tbody>${linhasTabela.join("")}</tbody>
//                 </table>
//               </div>
//               <div>
//                 <div class="print-total">Valor total: R$ <span>${totalGeralSecretaria.toFixed(2)}</span></div>
//                 <p>Validade: 60 dias</p>
//                 <p>${local}, ${dataFormatada}</p>
//                 <div class="print-assinaturas"><div class="print-assinatura"><div class="linha"></div><p>RESTAURANTE FOGAREIRO</p><p>CNPJ: 20.804.758/0001-90</p></div></div>
//               </div>
//             </main>
//             <footer class="print-rodape">Av. Zezé Jucá, centro de Lagoa do Mato, Itatira - CE <br />CEP: 62725-000 | CNPJ: 20.804.758/0001-90</footer>
//           </div>`
//         );
//       }
//     });
//     if (!abriuAlguma) { alert("Nenhuma secretaria possui itens selecionados para imprimir!"); return; }
//     setPrintHtml(paginasHtml.join(''));
//   };

//   // NOVO: Função que apenas GERA a string do XML.
//   const gerarStringXML = () => {
//     const notasXml = [];
//     let rpsNumeroBase = Date.now();
//     let algumItem = false;
    
//     Object.keys(cotacaoAtual).forEach((secretaria, index) => {
//         let baseCalculoSecretaria = 0;
//         const itensDaSecretaria = [];
//         cotacaoAtual[secretaria].forEach(item => {
//             if (item.usado > 0) {
//                 algumItem = true;
//                 baseCalculoSecretaria += item.usado * item.valor;
//                 const descricaoLimpa = removerAcentos(item.descricao);
//                 itensDaSecretaria.push(`${item.usado} - ${descricaoLimpa} VALOR UNITARIO: R$ ${item.valor.toFixed(2)}. TOTAL: R$ ${(item.usado * item.valor).toFixed(2)}`);
//             }
//         });
//         if (baseCalculoSecretaria > 0) {
//             const issRetido = baseCalculoSecretaria * 0.04;
//             const dataRps = date ? new Date(date + 'T00:00:00') : new Date();
//             const dataFormatada = dataRps.toISOString().split('T')[0];
//             const discriminacaoOriginal = `SERVIÇO DE ALIMENTAÇÃO FORNECIDO À SECRETARIA DE ${secretaria.toUpperCase()} DESTE MUNICÍPIO: ${itensDaSecretaria.join('; ')}`;
//             const discriminacaoLimpa = removerAcentos(discriminacaoOriginal);
//             const nota = `
//     <nota>
//         <rps_numero>${rpsNumeroBase + index}</rps_numero>
//         <rps_data>${dataFormatada}</rps_data>
//         <tomador_nome>${removerAcentos("MUNICÍPIO DE ITATIRA - PREFEITURA MUNICIPAL")}</tomador_nome>
//         <tomador_cnpjcpf>07.963.739/0001-48</tomador_cnpjcpf>
//         <tomador_inscrmunicipal></tomador_inscrmunicipal>
//         <tomador_logradouro>${removerAcentos("RUA PE. JOSÉ LAURINDO")}</tomador_logradouro>
//         <tomador_numero>1249</tomador_numero>
//         <tomador_complemento></tomador_complemento>
//         <tomador_bairro>CENTRO</tomador_bairro>
//         <tomador_cep>62720-000</tomador_cep>
//         <tomador_municipio>ITATIRA</tomador_municipio>
//         <tomador_uf>CE</tomador_uf>
//         <tomador_email>email@naoinformado.com</tomador_email>
//         <discriminacao>${discriminacaoLimpa}</discriminacao>
//         <observacao></observacao>
//         <aliqinss></aliqinss>
//         <aliqirrf></aliqirrf>
//         <deducaoirrf></deducaoirrf>
//         <valordeducoes></valordeducoes>
//         <estado>N</estado>
//         <codservico>14.19</codservico>
//         <basecalculo>${baseCalculoSecretaria.toFixed(2)}</basecalculo>
//         <issretido>${issRetido.toFixed(2)}</issretido>
//     </nota>`;
//             notasXml.push(nota);
//         }
//     });

//     if (!algumItem) {
//       return null; // Retorna nulo se não houver itens
//     }

//     return `<?xml version="1.0" encoding="UTF-8"?><importacao>${notasXml.join('')}</importacao>`;
//   }

//   // ALTERADO: Função de exportar agora usa a nova função 'gerarStringXML'
//   const exportarRPS_XML = () => {
//     const xmlFinal = gerarStringXML();

//     if (!xmlFinal) {
//       alert("Nenhum item foi selecionado para gerar o RPS!");
//       return;
//     }

//     const blob = new Blob([xmlFinal], { type: 'application/xml;charset=utf-8' });
//     const link = document.createElement("a");
//     link.href = URL.createObjectURL(blob);
//     link.download = "rps_lote.xml";
//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);
//   };
  
//   const handleLogout = async () => { await signOut(auth); navigate('/login'); };

//   if (!saldosMestre) { return <div className="app-container"><div>Carregando saldos do contrato...</div></div>; }

//   let totalGeral = 0;
//   const totaisSecretaria = {};
//   Object.keys(cotacaoAtual).forEach(secretaria => {
//     let totalSec = 0;
//     cotacaoAtual[secretaria].forEach(item => { totalSec += (item.usado || 0) * item.valor; });
//     totaisSecretaria[secretaria] = totalSec;
//     totalGeral += totalSec;
//   });

//   return (
//     <>
//       <div className="app-container">
//         <header>
//           <span>Fogareiro</span>
//           <button className="btn-logout" onClick={handleLogout}>Sair</button>
//         </header>

//         <div className="container">
//           <div className="config-container">
//             <div>
//               <label htmlFor="budget-date">Data do Orçamento:</label>
//               <input type="date" id="budget-date" value={date} onChange={(e) => setDate(e.target.value)} />
//             </div>
//             <button className="btn-historico" onClick={() => navigate('/historico')}>
//               Ver Histórico
//             </button>
//           </div>

//           <div className="secretarias">
//             {Object.keys(cotacaoAtual).map(secretaria => (
//               <div className="card" key={secretaria}>
//                 <h2>{secretaria}</h2>
//                 {cotacaoAtual[secretaria].map((item, index) => (
//                   <div className="item" key={index}>
//                     <div>
//                       <strong>{item.nome}</strong>
//                       <div className="saldo">Saldo: {saldosMestre?.[secretaria]?.[item.nome] ?? '...'}</div>
//                     </div>
//                     <input type="number" min="0" value={item.usado} onInput={(e) => alterarQtd(secretaria, index, e.target.value)} />
//                     <span>R$ {item.valor.toFixed(2)}</span>
//                     <div className="valor-item">R$ {((item.usado || 0) * item.valor).toFixed(2)}</div>
//                   </div>
//                 ))}
//                 <div className="card-footer"><strong>Total:</strong><span>R$ {totaisSecretaria[secretaria].toFixed(2)}</span></div>
//               </div>
//             ))}
//           </div>
          
//           <div className="total-geral-container">
//             <div className="grand-total-line">Valor Total da Cotação:<span>R$ {totalGeral.toFixed(2)}</span></div>
//           </div>

//           {/* === BARRA DE AÇÕES SEPARADA EM GRUPOS === */}
//           <div className="actions-container">
//             <div> {/* NOVO: Grupo de botões de exportação */}
//               <button className="btn" onClick={imprimirCotacoes}>Imprimir Cotações</button>
//               <button className="btn" onClick={gerarRelatorioTexto}>Gerar Relatório</button>
//               <button className="btn xml" onClick={exportarRPS_XML}>Exportar RPS (XML)</button>
//             </div>
            
//             {/* Botão de ação principal fica sozinho */}
//             <button className="btn-efetivar" onClick={handleEfetivarCotacao} disabled={isSaving}>
//               {isSaving ? "Salvando..." : "Efetivar e Baixar Saldo"}
//             </button>
//           </div>

//         </div>

//         {isModalOpen && (
//           <div id="text-report-modal" className="modal-overlay">
//             <div className="modal-content">
//               <h3>Relatório para Copiar</h3>
//               <p>O texto abaixo está pronto para ser copiado e colado onde você precisar.</p>
//               <textarea id="report-textarea" readOnly value={reportText}></textarea>
//               <button className="btn" onClick={() => setIsModalOpen(false)}>Fechar</button>
//             </div>
//           </div>
//         )}
//       </div>
//       <div className="print-only-container" dangerouslySetInnerHTML={{ __html: printHtml }} />
//     </>
//   );
// }

// export default Cotacao;


// src/pages/Cotacao.js - VERSÃO FINAL E ROBUSTA DE GERAÇÃO DE PDF
import React, { useState, useEffect } from 'react';
import { auth, db } from '../firebase';
import { doc, getDoc, setDoc } from 'firebase/firestore';
import { signOut } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import logoImage from '../assets/logo.png';

const itensContratoBase = [
    { nome: "Lanche simples", descricao: "Lanche simples – Sanduiche pão e ovo, salgados ou bolo com refrigerante e suco, café com leite.", valor: 18.50 },
    { nome: "Quentinha", descricao: "Quentinha – carne, frango ou peixe, arroz, feijão, farofa, salada ou baião e refrigerante.", valor: 27.00 },
    { nome: "Almoço", descricao: "Almoço – frango, carne ou linguiça, arroz, farofa, feijão, salada ou baião e refrigerante.", valor: 32.50 },
    { nome: "Coffee Break", descricao: "Coffee Break – por pessoa três tipos de salgados, dois tipos de frutas, torta salgada, bolo, pão, patês variados, torrada, dois tipos de suco, refrigerante, café e leite.", valor: 44.00 },
    { nome: "Buffet", descricao: "Buffet – (tipo americano) – 02 tipos de carnes vermelhas, 01 tipo de carne branca, 02 tipos de arroz (branco ou outro), 02 tipo de macarrão (espaguete ou fusilli), 02 tipo de farofa (farinha ou cuscuz), 02 tipos de salada (crua ou cozida), sobremesa gelada, bebidas: agua mineral 330ml ou agua mineral com gás 330ml e 250ml de sucos regionais ou 250ml de refrigerante, utensílios: copos, pratos, talheres, guardanapos de papel folha dupla.", valor: 78.50 }
];
const saldosMestreIniciais = {
  "Assistência Social": { "Lanche simples": 200, "Quentinha": 800, "Almoço": 200, "Coffee Break": 700, "Buffet": 1200 },
  "Finanças": { "Lanche simples": 300, "Quentinha": 1000, "Almoço": 300, "Coffee Break": 700, "Buffet": 1200 },
  "Saúde": { "Lanche simples": 100, "Quentinha": 500, "Almoço": 100, "Coffee Break": 700, "Buffet": 1200 },
  "Educação": { "Lanche simples": 300, "Quentinha": 1000, "Almoço": 300, "Coffee Break": 700, "Buffet": 1200 },
};
const criarCotacaoVazia = () => {
    const cotacaoVazia = {};
    Object.keys(saldosMestreIniciais).forEach(sec => {
        cotacaoVazia[sec] = itensContratoBase.map(item => ({ ...item, usado: 0 }));
    });
    return cotacaoVazia;
};
function removerAcentos(texto) {
    if (!texto) return "";
    return texto.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}


function Cotacao() {
  const navigate = useNavigate();
  const [cotacaoAtual, setCotacaoAtual] = useState(criarCotacaoVazia());
  const [saldosMestre, setSaldosMestre] = useState(null);
  const [isSaving, setIsSaving] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [reportText, setReportText] = useState('');
  const [date, setDate] = useState(new Date().toISOString().split('T')[0]);
  
  // Estados para controlar o processo de geração do PDF
  const [isPrinting, setIsPrinting] = useState(false);
  const [printContent, setPrintContent] = useState('');

  useEffect(() => {
    const carregarSaldos = async () => {
      const docRef = doc(db, "saldos", "por_secretaria");
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        const dadosDoFirestore = docSnap.data();
        const saldosCompletos = { ...saldosMestreIniciais };
        for (const sec in saldosCompletos) {
            if (dadosDoFirestore[sec]) {
                saldosCompletos[sec] = { ...saldosMestreIniciais[sec], ...dadosDoFirestore[sec] };
            }
        }
        setSaldosMestre(saldosCompletos);
      } else {
        await setDoc(docRef, saldosMestreIniciais);
        setSaldosMestre(saldosMestreIniciais);
      }
    };
    carregarSaldos();
  }, []);

  // NOVO: useEffect que observa o conteúdo de impressão e dispara a geração do PDF
  useEffect(() => {
    const gerarPdf = async () => {
      if (printContent && isPrinting) {
        const pdfContainer = document.getElementById('pdf-render-area');
        const paginasParaProcessar = pdfContainer.querySelectorAll('.pagina-cotacao');

        const pdf = new jsPDF('p', 'mm', 'a4');
        const pdfPageWidth = pdf.internal.pageSize.getWidth();

        for (let i = 0; i < paginasParaProcessar.length; i++) {
          const pagina = paginasParaProcessar[i];
          const canvas = await html2canvas(pagina, { scale: 2, useCORS: true });
          
          // Lógica para manter a proporção da imagem
          const canvasAspectRatio = canvas.width / canvas.height;
          const pageHeight = pdfPageWidth / canvasAspectRatio;

          const imgData = canvas.toDataURL('image/png');
          
          if (i > 0) {
            pdf.addPage();
          }
          pdf.addImage(imgData, 'PNG', 0, 0, pdfPageWidth, pageHeight);
        }
        
        pdf.save(`orcamento-${Date.now()}.pdf`);

        // Limpa os estados após a geração
        setPrintContent('');
        setIsPrinting(false);
      }
    };

    gerarPdf();
  }, [printContent, isPrinting]); // Dependências do useEffect

  const imprimirCotacoes = () => {
    let paginasHtml = [];
    let abriuAlguma = false;
    const dataOrcamento = new Date(date + 'T00:00:00');
    const dataFormatada = dataOrcamento.toLocaleDateString('pt-BR', { day: '2-digit', month: 'long', year: 'numeric' });
    const local = "Lagoa do Mato, Itatira - CE";
    
    Object.keys(cotacaoAtual).forEach(secretaria => {
      let linhasTabela = [];
      let totalGeralSecretaria = 0;
      let contador = 1;
      cotacaoAtual[secretaria].forEach(item => {
        if (item.usado > 0) {
          abriuAlguma = true;
          const totalItem = item.usado * item.valor;
          totalGeralSecretaria += totalItem;
          linhasTabela.push(`<tr><td>${contador++}</td><td>${item.descricao}</td><td>${item.usado}</td><td>R$ ${item.valor.toFixed(2)}</td><td>R$ ${totalItem.toFixed(2)}</td></tr>`);
        }
      });

      if (linhasTabela.length > 0) {
        paginasHtml.push(
          // Atenção: O caminho do logo deve ser a partir da pasta `public` do seu projeto.
          // Se sua logo estiver em `public/assets/logo.png`, o caminho é `/assets/logo.png`
          `<div class="pagina-cotacao">
            <header class="print-header"><div class="print-header-inner"><img src="${logoImage}" alt="Logo"></div></header>
            <main class="print-main">
              <div>
                <div class="print-titulo">ORÇAMENTO</div>
                <div class="print-cabecalho"><strong>Tomador:</strong> <span>MUNICÍPIO DE ITATIRA  - Secretaria de ${secretaria}</span><br /><strong>CNPJ:</strong> <span>07.963.739/0001-48</span></div>
                <table>
                  <thead><tr><th style="width:60px;">ITEM</th><th>ESPECIFICAÇÕES</th><th style="width:60px;">Qtd</th><th style="width:100px;">Valor unit.</th><th style="width:100px;">Total</th></tr></thead>
                  <tbody>${linhasTabela.join("")}</tbody>
                </table>
              </div>
              <div>
                <div class="print-total">Valor total: R$ <span>${totalGeralSecretaria.toFixed(2)}</span></div>
                <p>Validade: 60 dias</p>
                <p>${local}, ${dataFormatada}</p>
                <div class="print-assinaturas"><div class="print-assinatura"><div class="linha"></div><p>RESTAURANTE FOGAREIRO</p><p>CNPJ: 20.804.758/0001-90</p></div></div>
              </div>
            </main>
            <footer class="print-rodape">Av. Zezé Jucá, centro de Lagoa do Mato, Itatira - CE <br />CEP: 62725-000 | CNPJ: 20.804.758/0001-90</footer>
          </div>`
        );
      }
    });

    if (!abriuAlguma) {
      alert("Nenhuma secretaria possui itens selecionados para imprimir!");
      return;
    }

    // Apenas atualiza os estados. O useEffect cuidará do resto.
    setIsPrinting(true);
    setPrintContent(paginasHtml.join(''));
  };

  // ... (todas as outras funções que já estavam funcionando continuam aqui, sem alteração)
  const alterarQtd = (secretaria, itemIndex, novoValor) => {
    const valorNum = parseInt(novoValor) || 0;
    const item = cotacaoAtual[secretaria][itemIndex];
    const saldoDisponivel = saldosMestre[secretaria][item.nome];
    if (valorNum > saldoDisponivel) {
        alert(`Quantidade não permitida!\nO saldo máximo para "${item.nome}" na secretaria "${secretaria}" é ${saldoDisponivel}.`);
        const novaCotacao = { ...cotacaoAtual };
        novaCotacao[secretaria][itemIndex].usado = saldoDisponivel;
        setCotacaoAtual(novaCotacao);
        return;
    }
    const novaCotacao = { ...cotacaoAtual };
    novaCotacao[secretaria][itemIndex].usado = valorNum;
    setCotacaoAtual(novaCotacao);
  };
  const handleEfetivarCotacao = async () => {
    if (isSaving) return;
    let consumoTotal = 0;
    let valorTotalCotacao = 0;
    Object.values(cotacaoAtual).forEach(secretaria => {
        secretaria.forEach(item => { 
            consumoTotal += item.usado;
            valorTotalCotacao += item.usado * item.valor;
        });
    });

    if (consumoTotal === 0) {
      alert("Nenhum item foi adicionado à cotação para efetivar.");
      return;
    }
    const novosSaldosMestre = JSON.parse(JSON.stringify(saldosMestre));
    let validationFailed = false;
    for (const secretaria in cotacaoAtual) {
      for (const item of cotacaoAtual[secretaria]) {
        if (item.usado > 0) {
          if (saldosMestre[secretaria][item.nome] < item.usado) {
            validationFailed = true; break; 
          }
          novosSaldosMestre[secretaria][item.nome] -= item.usado;
        }
      }
      if (validationFailed) break;
    }
    if(validationFailed) { alert("Erro de validação. A quantidade excede o saldo disponível."); return; }
    if (window.confirm("Tem certeza que deseja efetivar esta cotação? Os saldos serão atualizados e a cotação será salva no histórico.")) {
      setIsSaving(true);
      try {
        const saldosDocRef = doc(db, "saldos", "por_secretaria");
        await setDoc(saldosDocRef, novosSaldosMestre);
        const idCotacao = `COT-${Date.now()}`;
        const historicoDocRef = doc(db, "historico_cotacoes", idCotacao);
        const xmlString = gerarStringXML();
        const dadosParaSalvar = {
            id: idCotacao,
            dataEfetivacao: new Date().toISOString(),
            dataOrcamento: date,
            status: "Efetivada",
            valorTotal: valorTotalCotacao,
            detalhes: cotacaoAtual,
            xmlString: xmlString
        };
        await setDoc(historicoDocRef, dadosParaSalvar);
        setSaldosMestre(novosSaldosMestre);
        setCotacaoAtual(criarCotacaoVazia());
        alert("Cotação efetivada e salva no histórico com sucesso!");
      } catch (error) {
        console.error("Erro ao efetivar cotação:", error);
        alert("Ocorreu um erro. Por favor, tente novamente.");
      } finally {
        setIsSaving(false);
      }
    }
  };
  const gerarRelatorioTexto = () => {
    let relatorios = [];
    let abriuAlguma = false;
    Object.keys(cotacaoAtual).forEach(secretaria => {
      let itensRelatorio = [];
      let totalSecretaria = 0;
      cotacaoAtual[secretaria].forEach(item => {
        if (item.usado > 0) {
          abriuAlguma = true;
          const valorTotalItem = item.usado * item.valor;
          totalSecretaria += valorTotalItem;
          const linhaItem = `${item.usado} - ${item.descricao} VALOR UNITÁRIO: R$ ${item.valor.toFixed(2)}. TOTAL: R$ ${valorTotalItem.toFixed(2)}`;
          itensRelatorio.push(linhaItem);
        }
      });
      if (itensRelatorio.length > 0) {
        let relatorioSecretaria = `SERVIÇO DE ALIMENTAÇÃO FORNECIDO À SECRETARIA DE ${secretaria.toUpperCase()} DESTE MUNICÍPIO\n\n`;
        relatorioSecretaria += itensRelatorio.join('\n');
        relatorioSecretaria += `\n\nTOTAL: R$ ${totalSecretaria.toFixed(2)}`;
        relatorios.push(relatorioSecretaria);
      }
    });
    if (!abriuAlguma) { alert("Nenhum item foi selecionado para gerar o relatório!"); return; }
    const textoFinal = relatorios.join('\n\n==================================================\n\n');
    setReportText(textoFinal);
    setIsModalOpen(true);
  };
  const gerarStringXML = () => {
    const notasXml = [];
    let rpsNumeroBase = Date.now();
    let algumItem = false;
    Object.keys(cotacaoAtual).forEach((secretaria, index) => {
        let baseCalculoSecretaria = 0;
        const itensDaSecretaria = [];
        cotacaoAtual[secretaria].forEach(item => { if (item.usado > 0) { algumItem = true; baseCalculoSecretaria += item.usado * item.valor; const descricaoLimpa = removerAcentos(item.descricao); itensDaSecretaria.push(`${item.usado} - ${descricaoLimpa} VALOR UNITARIO: R$ ${item.valor.toFixed(2)}. TOTAL: R$ ${(item.usado * item.valor).toFixed(2)}`); } });
        if (baseCalculoSecretaria > 0) {
            const issRetido = baseCalculoSecretaria * 0.04;
            const dataRps = date ? new Date(date + 'T00:00:00') : new Date();
            const dataFormatada = dataRps.toISOString().split('T')[0];
            const discriminacaoOriginal = `SERVIÇO DE ALIMENTAÇÃO FORNECIDO À SECRETARIA DE ${secretaria.toUpperCase()} DESTE MUNICÍPIO: ${itensDaSecretaria.join('; ')}`;
            const discriminacaoLimpa = removerAcentos(discriminacaoOriginal);
            const nota = `
    <nota>
        <rps_numero>${rpsNumeroBase + index}</rps_numero>
        <rps_data>${dataFormatada}</rps_data>
        <tomador_nome>${removerAcentos("MUNICÍPIO DE ITATIRA - PREFEITURA MUNICIPAL")}</tomador_nome>
        <tomador_cnpjcpf>07.963.739/0001-48</tomador_cnpjcpf>
        <tomador_inscrmunicipal></tomador_inscrmunicipal>
        <tomador_logradouro>${removerAcentos("RUA PE. JOSÉ LAURINDO")}</tomador_logradouro>
        <tomador_numero>1249</tomador_numero>
        <tomador_complemento></tomador_complemento>
        <tomador_bairro>CENTRO</tomador_bairro>
        <tomador_cep>62720-000</tomador_cep>
        <tomador_municipio>ITATIRA</tomador_municipio>
        <tomador_uf>CE</tomador_uf>
        <tomador_email>email@naoinformado.com</tomador_email>
        <discriminacao>${discriminacaoLimpa}</discriminacao>
        <observacao></observacao>
        <aliqinss></aliqinss>
        <aliqirrf></aliqirrf>
        <deducaoirrf></deducaoirrf>
        <valordeducoes></valordeducoes>
        <estado>N</estado>
        <codservico>14.19</codservico>
        <basecalculo>${baseCalculoSecretaria.toFixed(2)}</basecalculo>
        <issretido>${issRetido.toFixed(2)}</issretido>
    </nota>`;
            notasXml.push(nota);
        }
    });
    if (!algumItem) return null;
    return `<?xml version="1.0" encoding="UTF-8"?><importacao>${notasXml.join('')}</importacao>`;
  }
  const exportarRPS_XML = () => {
    const xmlFinal = gerarStringXML();
    if (!xmlFinal) { alert("Nenhum item foi selecionado para gerar o RPS!"); return; }
    const blob = new Blob([xmlFinal], { type: 'application/xml;charset=utf-8' });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = "rps_lote.xml";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  const handleLogout = async () => { await signOut(auth); navigate('/login'); };

  if (!saldosMestre) { return <div className="app-container"><div>Carregando saldos do contrato...</div></div>; }
  
  let totalGeral = 0;
  const totaisSecretaria = {};
  Object.keys(cotacaoAtual).forEach(secretaria => { let totalSec = 0; cotacaoAtual[secretaria].forEach(item => { totalSec += (item.usado || 0) * item.valor; }); totaisSecretaria[secretaria] = totalSec; totalGeral += totalSec; });

  return (
    <>
      <div className="app-container">
        {/* O JSX principal não muda, exceto pelo botão de imprimir */}
        <header>
          <span>Fogareiro</span>
          <button className="btn-logout" onClick={handleLogout}>Sair</button>
        </header>
        <div className="container">
          <div className="config-container">
            <div>
              <label htmlFor="budget-date">Data do Orçamento:</label>
              <input type="date" id="budget-date" value={date} onChange={(e) => setDate(e.target.value)} />
            </div>
            <button className="btn-historico" onClick={() => navigate('/historico')}>Ver Histórico</button>
          </div>
          <div className="secretarias">
            {Object.keys(cotacaoAtual).map(secretaria => (
              <div className="card" key={secretaria}>
                <h2>{secretaria}</h2>
                {cotacaoAtual[secretaria].map((item, index) => (
                  <div className="item" key={index}>
                    <div><strong>{item.nome}</strong><div className="saldo">Saldo: {saldosMestre?.[secretaria]?.[item.nome] ?? '...'}</div></div>
                    <input type="number" min="0" value={item.usado} onInput={(e) => alterarQtd(secretaria, index, e.target.value)} />
                    <span>R$ {item.valor.toFixed(2)}</span>
                    <div className="valor-item">R$ {((item.usado || 0) * item.valor).toFixed(2)}</div>
                  </div>
                ))}
                <div className="card-footer"><strong>Total:</strong><span>R$ {totaisSecretaria[secretaria].toFixed(2)}</span></div>
              </div>
            ))}
          </div>
          <div className="total-geral-container"><div className="grand-total-line">Valor Total da Cotação:<span>R$ {totalGeral.toFixed(2)}</span></div></div>
          <div className="actions-container">
            <div>
              <button className="btn" onClick={imprimirCotacoes} disabled={isPrinting}>
                {isPrinting ? 'Gerando PDF...' : 'Imprimir Cotações'}
              </button>
              <button className="btn" onClick={gerarRelatorioTexto}>Gerar Relatório</button>
              <button className="btn xml" onClick={exportarRPS_XML}>Exportar RPS (XML)</button>
            </div>
            <button className="btn-efetivar" onClick={handleEfetivarCotacao} disabled={isSaving}>{isSaving ? "Salvando..." : "Efetivar e Baixar Saldo"}</button>
          </div>
        </div>
        {isModalOpen && (<div id="text-report-modal" className="modal-overlay"><div className="modal-content"><h3>Relatório para Copiar</h3><p>O texto abaixo está pronto para ser copiado e colado onde você precisar.</p><textarea id="report-textarea" readOnly value={reportText}></textarea><button className="btn" onClick={() => setIsModalOpen(false)}>Fechar</button></div></div>)}
      </div>

      {/* Área invisível para renderizar o HTML do PDF antes de capturar */}
      <div id="pdf-render-area" style={{ position: 'absolute', left: '-9999px', top: 0 }}
           dangerouslySetInnerHTML={{ __html: printContent }} />
    </>
  );
}

export default Cotacao;
